import { EventEmitter, OnInit } from '@angular/core';
import * as _ from 'lodash';
var ThumbsComponent = /** @class */ (function () {
    function ThumbsComponent() {
        this.showGrey = false;
        this.incremented = new EventEmitter();
    }
    Object.defineProperty(ThumbsComponent.prototype, "absValue", {
        get: function () {
            return Math.abs(this.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThumbsComponent.prototype, "invertedAbsValue", {
        get: function () {
            return this.items.length - this.absValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThumbsComponent.prototype, "sign", {
        get: function () {
            return this.value > 0 ? 1 : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThumbsComponent.prototype, "type", {
        get: function () {
            return this.sign > 0 ? 'pro' : 'con';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThumbsComponent.prototype, "items", {
        get: function () {
            return _.range(3);
        },
        enumerable: true,
        configurable: true
    });
    ThumbsComponent.prototype.ngOnInit = function () { };
    ThumbsComponent.prototype.onClicked = function () {
        this.incremented.emit();
    };
    return ThumbsComponent;
}());
export { ThumbsComponent };



// WEBPACK FOOTER //
// ./src/app/components/_shared/thumbs/thumbs.component.ts.pre-build-optimizer.js